import React from 'react'
import { Box, Grid, Typography, Stack } from '@mui/material'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'

import emaar from '../Images/Emaar-Properties-Logo-1.png'
import arada from '../Images/aradafile.png'
import binghatti from '../Images/binghatti.webp'
import azizi from '../Images/azizi.webp'
import danube from '../Images/Danube-Logo.png'
import sobha from '../Images/sobha-ZMhITtfQCc.png'
import alef from '../Images/aleflogo.png'
import merath from '../Images/Meraas-logo.svg'
import museumBg from '../Images/musium.png'

const developersList = [emaar, arada, binghatti, azizi, danube, sobha, alef, merath]

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: (delay = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: 'easeOut', delay },
  }),
}

export const HomeDevelopers = () => {
  const { t, i18n } = useTranslation()
  const isArabic = (i18n.language || 'ar').startsWith('ar')

  return (
    <Box sx={{ position: 'relative', bgcolor: '#2B2B2B', py: { xs: 8, md: 12 }, overflow: 'hidden' }}>
      {/* الخلفية الشفافة */}
      <Box
        component="img"
        src={museumBg}
        alt=""
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '140%', md: '75%' },
          maxWidth: 1100,
          opacity: 0.18,
          pointerEvents: 'none',
          userSelect: 'none',
          zIndex: 0,
        }}
      />

      {/* ريشة تلاشي سفلية - بنفس لون خلفية السيكشن (#2B2B2B) عشان تندمج مع سيكشن الـ Projects اللي بعده */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: { xs: 140, md: 260 },
          background: `linear-gradient(to top,
            rgba(43,43,43,1) 0%,
            rgba(43,43,43,0.9) 20%,
            rgba(43,43,43,0.7) 40%,
            rgba(43,43,43,0.4) 65%,
            rgba(43,43,43,0.1) 85%,
            rgba(43,43,43,0) 100%)`,
          zIndex: 2,
          pointerEvents: 'none',
        }}
      />

      <Box sx={{ position: 'relative', zIndex: 1, maxWidth: 1300, mx: 'auto', px: { xs: 3, md: 6 } }}>
        <Box
          component={motion.div}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.6 }}
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', md: 'flex-end' },
            gap: 2,
            mb: { xs: 5, md: 7 },
          }}
        >
          <Box>
            <Typography
              component={motion.p}
              custom={0}
              variants={fadeUp}
              variant="overline"
              sx={{ color: '#7A2E3A', fontWeight: 700, letterSpacing: 2, display: 'block' }}
            >
              {t('developers.eyebrow')}
            </Typography>
            <Typography
              component={motion.h2}
              custom={0.1}
              variants={fadeUp}
              sx={{
                fontFamily: isArabic ? "'El Messiri', serif" : "'Bodoni Moda', serif",
                fontWeight: isArabic ? 700 : 500,
                fontSize: { xs: '2.2rem', md: '3rem' },
                color: '#D9D6CF',
                mt: 0.5,
                lineHeight: 1,
              }}
            >
              {t('developers.title')}
            </Typography>
          </Box>

          <Typography
            component={motion.p}
            custom={0.2}
            variants={fadeUp}
            sx={{
              fontFamily: isArabic ? "'El Messiri', serif" : "'Bodoni Moda', serif",
              fontStyle: isArabic ? 'normal' : 'italic',
              fontSize: { xs: '1.1rem', md: '1.4rem' },
              color: 'rgba(217,214,207,0.7)',
              whiteSpace: 'nowrap',
              lineHeight: 1,
              alignSelf: 'flex-end',
            }}
          >
            {t('developers.tagline')}
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: 'repeat(2, 1fr)',
              sm: 'repeat(3, 1fr)',
              md: 'repeat(4, 1fr)',
            },
            border: '1px solid rgba(217,214,207,0.15)',
            borderRadius: '4px',
            overflow: 'hidden',
            backdropFilter: 'blur(2px)',
          }}
        >
          {developersList.map((logo, index) => (
            <Box
              key={index}
              component={motion.div}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: false, amount: 0.3 }}
              transition={{ duration: 0.5, delay: (index % 4) * 0.08 }}
              whileHover={{ scale: 1.04 }}
              sx={{
                height: { xs: 120, sm: 140, md: 170 },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                p: { xs: 2.5, md: 4 },
                borderRight: '1px solid rgba(217,214,207,0.15)',
                borderBottom: '1px solid rgba(217,214,207,0.15)',
                bgcolor: 'rgba(43,43,43,0.55)',
                transition: 'background-color 0.3s ease',
                '&:hover': { bgcolor: 'rgba(122,46,58,0.15)' },
              }}
            >
              <Box
                component="img"
                src={logo}
                alt={`developer-${index}`}
                sx={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  filter: 'brightness(0) invert(1)',
                  opacity: 0.9,
                  transition: 'opacity 0.3s ease',
                  '&:hover': { opacity: 1 },
                }}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  )
}